import { Box } from '@palmetto/palmetto-components';

import { AccountActivityRecord, DispatchLeadRejectionReason } from 'types';

import EventBy from './EventBy';

export interface SabalLeadRejectedEventData {
  projectId?: string;
  accountId?: string;
  rejectionReason?: DispatchLeadRejectionReason;
  // Index signature so this satisfies EventBy's ActivityEvent['data'] (Record<string, unknown>).
  [key: string]: unknown;
}

type SabalLeadRejectedEvent = Omit<AccountActivityRecord, 'data'> & {
  data: SabalLeadRejectedEventData;
};

const SabalLeadRejected = ({ event }: { event: SabalLeadRejectedEvent }) => {
  const rejectionReason = event.data?.rejectionReason;
  return (
    <Box display="block">
      <EventBy event={event} /> rejected lead
      {rejectionReason && (
        <>
          : <strong>{rejectionReason}</strong>
        </>
      )}
    </Box>
  );
};

export default SabalLeadRejected;
